const GoogleMaps = require('./../../../../../global/js/modules/google-maps'),
    VueUtils = require('../../../modules/vue-utils');

function _maybeSetupItineraryMap() {
    let $mapElement = document.querySelector('.itinerary .itinerary-location-map'),
        $coordinateElement = $mapElement ? $mapElement.querySelector('[type="text/gps-coordinates"]') : null,
        $viewButton = document.querySelector('.location-details.location-address a.view-on-map'),
        modal = VueUtils.getRef('modal-dialog')
    ;

    if (!$mapElement || !$coordinateElement || !$viewButton || !modal) {
        if ($mapElement) {
            $mapElement.remove();
        }

        if ($viewButton) {
            $viewButton.remove();
        }
        return;
    }

    let markers = [];

    const coordinate = JSON.parse($coordinateElement.innerText);

    if (!coordinate) {
        return;
    }

    GoogleMaps.insertMap($mapElement, {
        center: coordinate,
        zoom: 17
    }).then((map) => {
        $coordinateElement._marker = new google.maps.Marker({
            position: coordinate,
            map: map
        });

        $coordinateElement._marker.setMap(map);
        markers.push($coordinateElement._marker);
    });

    $viewButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();

        modal.setContent($mapElement, true);

        return false;
    });

}

function _maybeSetupButtonProtection() {
    const $buttons = document.querySelectorAll('.detailCard.controls a.button, .accept-and-book input[type="submit"], .form-actions input[type="submit"]');

    if ($buttons.length === 0) {
        return;
    }

    const throbber = VueUtils.getRef('global-throbber');

    const callback = event => {
        throbber.show();

        for (let $button of $buttons) {
            $button.classList.add('disabled');
            window.setTimeout(() => {
                $button.setAttribute('disabled', 'disabled');
            }, 10);
        }

        return true;
    };

    for (let $button of $buttons) {
        if ($button.tagName === 'A') {
            $button.addEventListener('click', callback);
        }
        else {
            let $form = $button.closest('form');
            //just in case a different button added it...
            $form.removeEventListener('submit', callback);
            $form.addEventListener('submit', callback);
        }

    }

}

document.addEventListener('DOMContentLoaded', () => {

    if (!document.querySelector('html.make-booking')) {
        return;
    }

    _maybeSetupItineraryMap();

    _maybeSetupButtonProtection();

});